import React from 'react'

function TermosECondicoes() {
  return (
    <div>TermosECondicoes</div>
  )
}

export default TermosECondicoes